import React, { useState, useEffect } from "react";
import "./ProductDetail.css";
import API_URL from "../apiConfig";

const API_BASE_URL = API_URL;

const ProductDetail = ({ product, onBack }) => {
  const [selectedImage, setSelectedImage] = useState(0);
  const [selectedSize, setSelectedSize] = useState(null);
  const [isInWishlist, setIsInWishlist] = useState(false);

  const userStr = localStorage.getItem("user");
  const user = userStr ? JSON.parse(userStr) : null;

  useEffect(() => {
    if (user && product) {
      checkWishlistStatus();
    }
  }, [product]);

  const checkWishlistStatus = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/api/wishlist`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await res.json();
      const exists = data.products?.some((p) => p._id === product._id);
      setIsInWishlist(exists);
    } catch (err) {
      console.error("Check wishlist error:", err);
    }
  };

  const handleWishlistToggle = async () => {
    if (!user) {
      alert("Please login to wishlist products");
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/api/wishlist/toggle`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ productId: product._id }),
      });
      if (res.ok) {
        setIsInWishlist(!isInWishlist);
      }
    } catch (err) {
      console.error("Wishlist toggle error:", err);
    }
  };

  if (!product) return null;


  const getImageUrl = (img) => {
    if (!img) return "https://via.placeholder.com/400x533?text=No+Image";
    return img.startsWith("http") ? img : `${API_BASE_URL}${img}`;
  };
  const addToBag = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      alert("Please login to add items to bag");
      return;
    }

    if (!selectedSize) {
      alert("Please select a size first");
      return;
    }

    try {
      const payload = {
        productId: product._id,
        quantity: 1,
        size: selectedSize,
        color: product.colors?.[0] || "Default",
      };

      const res = await fetch(`${API_BASE_URL}/api/cart`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (res.ok) {
        alert("Added to bag successfully!");
      } else {
        alert("Failed to add to bag");
      }
    } catch (error) {
      console.error("Add to bag failed:", error);
    }
  };
  const discount =
    product.originalPrice && product.originalPrice > product.price
      ? Math.round(
          ((product.originalPrice - product.price) / product.originalPrice) *
            100,
        )
      : null;

  return (
    <div className="product-detail-container">
      <div className="container">
        <button className="back-btn" onClick={onBack}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          Back to Listings
        </button>

        <div className="product-view">
          {/* Left: Image Gallery */}
          <div className="image-gallery">
            <div className="thumbnails">
              {product.images?.map((img, index) => (
                <div
                  key={index}
                  className={`thumb ${selectedImage === index ? "active" : ""}`}
                  onClick={() => setSelectedImage(index)}
                >
                  <img src={getImageUrl(img)} alt="" />
                </div>
              ))}
            </div>
            <div className="main-image">
              <img
                src={getImageUrl(product.images?.[selectedImage])}
                alt={product.name}
              />
            </div>
          </div>

          {/* Right: Product Info */}
          <div className="product-details">
            <div className="details-header">
              <h1 className="brand-name">{product.brand}</h1>
              <h2 className="product-title">{product.name}</h2>
              <div className="rating-badge">
                {product.rating || 4.2} ★ | {product.numReviews || 120} Ratings
              </div>
            </div>

            <div className="price-section">
              <span className="price">₹{product.price}</span>
              {product.originalPrice > product.price && (
                <>
                  <span className="mrp">MRP ₹{product.originalPrice}</span>
                  <span className="discount-tag">({discount}% OFF)</span>
                </>
              )}
              <p className="tax-info">inclusive of all taxes</p>
            </div>

            <div className="selection-section">
              <div className="section-header">
                <h3>SELECT SIZE</h3>
                <span className="size-chart">SIZE CHART &gt;</span>
              </div>
              <div className="size-options">
                {product.sizes?.map((size) => (
                  <button
                    key={size}
                    className={`size-btn ${selectedSize === size ? "active" : ""}`}
                    onClick={() => setSelectedSize(size)}
                  >
                    {size}
                  </button>
                ))}
              </div>
            </div>

            <div className="action-buttons">
              <button className="add-to-bag" onClick={addToBag}>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                >
                  <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" />
                  <path d="M3 6h18" />
                  <path d="M16 10a4 4 0 0 1-8 0" />
                </svg>
                ADD TO BAG
              </button>
              <button
                className={`wishlist-btn ${isInWishlist ? "active" : ""}`}
                onClick={handleWishlistToggle}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill={isInWishlist ? "var(--primary)" : "none"}
                  stroke={isInWishlist ? "var(--primary)" : "currentColor"}
                  strokeWidth="2"
                >
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                </svg>
                {isInWishlist ? "WISHLISTED" : "WISHLIST"}
              </button>
            </div>

            <div className="product-description">
              <h3>PRODUCT DETAILS</h3>
              <p className="description-text">{product.description}</p>

              <div className="specs-grid">
                <div className="spec-item">
                  <span className="spec-label">Fabric</span>
                  <span className="spec-value">
                    {product.fabric || "Cotton"}
                  </span>
                </div>
                <div className="spec-item">
                  <span className="spec-label">Color</span>
                  <span className="spec-value">
                    {(product.colors || []).join(", ")}
                  </span>
                </div>
                <div className="spec-item">
                  <span className="spec-label">Category</span>
                  <span className="spec-value">{product.subCategory}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
